module.exports = __webpack_public_path__ + "create/static/media/top_banner.17f7263f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/CreateGym/Institucional/top_banner.jpg
// module id = 500
// module chunks = 39